export default {
  setGameState(state, newState) {
    state.gameState = newState;
    // setDeepState(state, newState);
  },

  setGameId(state, gameId) {
    state.gameState.gameId = gameId;
  },

  setGameRef(state, gameRef) {
    state.gameRef = gameRef;
  },

  gameStateHasLoaded(state) {
    state.hasGameStateLoaded = true;
  },

  setPlayerRef(state, playerRef) {
    state.playerRef = playerRef;
  },

  setLocalStorage(state, data) {
    state.localStorage = data;
  },

  addGameToLocalStorage(state, { gameId, playerId }) {
    state.localStorage.push({ gameId, playerId });
  },

  setSoundFile(state, { fileName, sound }) {
    state.soundFile = {
      fileName,
      sound,
    };
  },
}
